import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Contexts/AuthContext';
import styles from './AdminNavbar.module.scss';

const AdminNavbar: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Erro ao fazer logout:', error);
    }
  };

  const handleBackToAdmin = () => {
    navigate('/admin');
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <nav className={styles.navbar}>
        <div className={styles.navbarContent}>
          <div className={styles.logoContainer}>
            <div className={styles.logo}>
              <h1>Eco Admin</h1>
            </div>
            
            <button 
              className={`${styles.menuButton} ${isMenuOpen ? styles.open : ''}`}
              onClick={toggleMenu}
              aria-label="Menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
          
          <div className={`${styles.navbarRight} ${isMenuOpen ? styles.open : ''}`}>
            <div className={styles.userInfo}>
              <div className={styles.userAvatar}>
                {user?.displayName?.charAt(0) || user?.email?.charAt(0) || 'U'}
              </div>
              <div className={styles.userDetails}>
                <span className={styles.userName}>{user?.displayName || user?.email}</span>
                <span className={styles.userRole}>Administrador</span>
              </div>
            </div>
            
            <div className={styles.navActions}>
              <button onClick={handleBackToAdmin} className={styles.backButton}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
                Voltar
              </button>
              <button onClick={handleLogout} className={styles.logoutButton}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
                Sair
              </button>
            </div>
          </div>
        </div>
      </nav>
      
      {isMenuOpen && (
        <div className={styles.mobileOverlay} onClick={toggleMenu}></div>
      )}
    </>
  );
};

export default AdminNavbar;